import React, { FunctionComponent } from "react";

import FormControlLabel, {
  FormControlLabelProps,
} from "@mui/material/FormControlLabel";
import styled from "@mui/material/styles/styled";

import Checkbox from "@rui/Checkbox";

type ApplyToSeriesProps = Omit<FormControlLabelProps, "control" | "label"> & {
  label?: FormControlLabelProps["label"];
  size?: "sm" | "md";
  checkedColor?: React.CSSProperties["color"];
};

const ApplyToSeries = styled<FunctionComponent<ApplyToSeriesProps>>(
  ({ checkedColor: _cc, size: _s, ...props }) => (
    <FormControlLabel
      {...props}
      control={<Checkbox disableRipple />}
      label={props.label ?? "Apply to all meetings in series"}
    />
  )
)(({ checkedColor, size = "sm", theme }) => ({
  marginLeft: theme.spacing(-1),
  "& .MuiFormControlLabel-label": {
    fontSize: size === "md" ? "0.875rem" : "0.75rem",
    color: theme.palette.shades.neutral[600],
    lineHeight: 1.25,
  },
  "& .checkbox__icon": {
    height: size === "md" ? "18px" : "15px",
    width: size === "md" ? "18px" : "15px",
    borderWidth: "2px",
    "&.checkbox__icon--checked": {
      borderColor: checkedColor ?? theme.palette.shades.neutral[400],
      "& svg": {
        fontSize: "20px",
        color: checkedColor ?? theme.palette.shades.neutral[400],
      },
    },
  },
}));

export default ApplyToSeries;
